



























































































































































import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { cloneDeep } from 'lodash';
import { Campaign } from '@/data/models/campaign.model';
import store from '@/store';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class CampagnaGeneralData extends Vue {
	@Prop() campagna!: Campaign;
	@Prop() editable!: boolean;

	@Inject('CrudService') campagnaCrudService!: CrudService<Campaign>;

	newCampagna!: Campaign;

	constructor() {
		super();
		this.newCampagna = new Campaign();
	}

	@Watch('campagna', { immediate: true })
	onCampagnaChangee() {
		this.newCampagna = cloneDeep(this.campagna);
	}

	submit() {
		this.newCampagna.hqid = store.headquarter!.id;
		this.newCampagna.stopdate?.setHours(23,23,59);
		this.campagnaCrudService.createEntity(Campaign, 'campaign', this.newCampagna).then(result => {
			this.newCampagna = result;
			this.$emit('update:campagna', result);
			if (!this.newCampagna.id) this.$router.push(`${result.id}/edit`);
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

}
